var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { width: _vm.dialogWidth },
      on: {
        keydown: [
          function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
            )
              return null
            return _vm.cancel.apply(null, arguments)
          },
          function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            )
              return null
            $event.preventDefault()
            return _vm.handleEnter.apply(null, arguments)
          },
        ],
      },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        {
          staticClass: "resizable-card",
          class: { "no-select": _vm.resizing },
          style: { height: _vm.dialogHeight + "px" },
        },
        [
          _c(
            "v-card-title",
            [
              _c("span", { staticClass: "headline" }, [
                _vm._v("Patch Builder"),
              ]),
              _c("v-spacer"),
              _c(
                "div",
                { staticClass: "d-flex align-center" },
                [
                  _c("v-switch", {
                    attrs: {
                      label: "Smart Offers from root",
                      dense: "",
                      "hide-details": "",
                      color: "primary",
                    },
                    model: {
                      value: _vm.transformSmartOffers,
                      callback: function ($$v) {
                        _vm.transformSmartOffers = $$v
                      },
                      expression: "transformSmartOffers",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-text",
            [
              _c(
                "v-form",
                {
                  ref: "form",
                  model: {
                    value: _vm.formValid,
                    callback: function ($$v) {
                      _vm.formValid = $$v
                    },
                    expression: "formValid",
                  },
                },
                [
                  _c("div", { staticClass: "mb-2" }, [
                    _c("strong", [_vm._v("Current Config ID:")]),
                    _c("span", { staticClass: "text--secondary" }, [
                      _vm._v(_vm._s(_vm.currConfigUID)),
                    ]),
                  ]),
                  _c("v-autocomplete", {
                    attrs: {
                      items: _vm.availableConfigs,
                      loading: _vm.isLoading,
                      dense: "",
                      outlined: "",
                      "item-text": "name",
                      "item-value": "uid",
                      "return-object": "",
                      "hide-details": "",
                      label: "Select base config to compare with",
                      placeholder: "Choose a config...",
                      rules: [(v) => !!v || "Please select a config"],
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "item",
                        fn: function ({ item }) {
                          return [
                            _c(
                              "v-list-item-content",
                              [
                                _c("v-list-item-title", [
                                  _vm._v(_vm._s(item.name)),
                                ]),
                                _c("v-list-item-subtitle", [
                                  _vm._v(_vm._s(item.uid)),
                                ]),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                    model: {
                      value: _vm.selectedConfig,
                      callback: function ($$v) {
                        _vm.selectedConfig = $$v
                      },
                      expression: "selectedConfig",
                    },
                  }),
                  _vm.errorMessage
                    ? _c("div", { staticClass: "ap-pb__error mt-2" }, [
                        _vm._v(" " + _vm._s(_vm.errorMessage) + " "),
                      ])
                    : _vm._e(),
                  _c(
                    "v-row",
                    { staticClass: "mt-2" },
                    [
                      _c(
                        "v-col",
                        { staticClass: "col-12" },
                        [
                          _c("v-text-field", {
                            directives: [
                              { name: "ascii-only", rawName: "v-ascii-only" },
                            ],
                            attrs: {
                              label: "Patch name",
                              required: "",
                              rules: [(v) => !!v || "Patch name is required"],
                            },
                            model: {
                              value: _vm.patchName,
                              callback: function ($$v) {
                                _vm.patchName = $$v
                              },
                              expression: "patchName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    { staticClass: "mt-4" },
                    [
                      _c(
                        "v-col",
                        { staticClass: "col-12" },
                        [
                          _c("v-autocomplete", {
                            attrs: {
                              items: _vm.availableMapKinds,
                              loading: _vm.isLoading,
                              "item-text": (item) =>
                                item.key + " - " + item.code,
                              "item-value": "code",
                              label: "Select Map(s):",
                              "return-object": "",
                              multiple: "",
                              "small-chips": "",
                              "deletable-chips": "",
                              rules: _vm.mapKindsRules,
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "item",
                                fn: function ({ item }) {
                                  return [
                                    _c(
                                      "v-list-item-content",
                                      [
                                        _c("v-list-item-title", [
                                          _vm._v(
                                            "Map: " +
                                              _vm._s(item.key) +
                                              " - Code: " +
                                              _vm._s(item.code)
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ]),
                            model: {
                              value: _vm.selectedMapKinds,
                              callback: function ($$v) {
                                _vm.selectedMapKinds = $$v
                              },
                              expression: "selectedMapKinds",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    { staticClass: "mt-4" },
                    [
                      _c(
                        "v-col",
                        { staticClass: "col-12" },
                        [
                          _c("v-autocomplete", {
                            attrs: {
                              items: _vm.availableMapGroups,
                              loading: _vm.isLoading,
                              "item-text": (item) =>
                                item.key + " - " + item.code,
                              "item-value": "code",
                              label: "Select Map Group(s):",
                              "return-object": "",
                              multiple: "",
                              "small-chips": "",
                              "deletable-chips": "",
                              rules: _vm.mapGroupsRules,
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "item",
                                fn: function ({ item }) {
                                  return [
                                    _c(
                                      "v-list-item-content",
                                      [
                                        _c("v-list-item-title", [
                                          _vm._v(
                                            "Group: " +
                                              _vm._s(item.key) +
                                              " - Code: " +
                                              _vm._s(item.code)
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ]),
                            model: {
                              value: _vm.selectedMapGroups,
                              callback: function ($$v) {
                                _vm.selectedMapGroups = $$v
                              },
                              expression: "selectedMapGroups",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    { staticClass: "mt-4" },
                    [
                      _c(
                        "v-col",
                        { staticClass: "col-12" },
                        [
                          _c("v-autocomplete", {
                            attrs: {
                              items: _vm.availableMapKinds,
                              loading: _vm.isLoading,
                              "item-text": (item) =>
                                item.key + " - " + item.code,
                              "item-value": "code",
                              label: "Select Map(s) to Exclude:",
                              "return-object": "",
                              multiple: "",
                              "small-chips": "",
                              "deletable-chips": "",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "item",
                                fn: function ({ item }) {
                                  return [
                                    _c(
                                      "v-list-item-content",
                                      [
                                        _c("v-list-item-title", [
                                          _vm._v(
                                            "Map: " +
                                              _vm._s(item.key) +
                                              " - Code: " +
                                              _vm._s(item.code)
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ]),
                            model: {
                              value: _vm.selectedMapExcluded,
                              callback: function ($$v) {
                                _vm.selectedMapExcluded = $$v
                              },
                              expression: "selectedMapExcluded",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    { staticClass: "mt-0" },
                    [
                      _c(
                        "v-col",
                        { staticClass: "col-8" },
                        [
                          _c("v-text-field", {
                            directives: [
                              { name: "ascii-only", rawName: "v-ascii-only" },
                            ],
                            attrs: {
                              label: "A/B Test ID",
                              required: "",
                              rules: _vm.abTestIdRules,
                            },
                            model: {
                              value: _vm.abTestId,
                              callback: function ($$v) {
                                _vm.abTestId = $$v
                              },
                              expression: "abTestId",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        [
                          _c("v-autocomplete", {
                            attrs: {
                              items: _vm.abTestGroups,
                              label: "A/B Test Group",
                              required: "",
                              "hide-details": "",
                              rules: _vm.abTestGroupRules,
                            },
                            model: {
                              value: _vm.abTestGroup,
                              callback: function ($$v) {
                                _vm.abTestGroup = $$v
                              },
                              expression: "abTestGroup",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            { staticClass: "resizable-card__actions" },
            [
              _vm.validationRan
                ? _c(
                    "div",
                    { staticClass: "ap-pb__valid" },
                    [
                      _c("div", { staticClass: "overline" }, [
                        _vm._v("Validation"),
                      ]),
                      _c(
                        "v-icon",
                        {
                          class: _vm.validationError
                            ? "error--text"
                            : "success--text",
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.validationError
                                  ? "mdi-close-circle"
                                  : "mdi-check-decagram"
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { text: "", disabled: _vm.isLoading },
                  on: { click: _vm.cancel },
                },
                [_vm._v(" Cancel ")]
              ),
              _c(
                "v-btn",
                {
                  attrs: {
                    color: "success",
                    disabled: !_vm.canBuildPatch,
                    loading: _vm.isLoading,
                  },
                  on: { click: _vm.buildPatch },
                },
                [_vm._v(" Build Patch ")]
              ),
            ],
            1
          ),
          _c("div", {
            staticClass: "resize-handle",
            on: { mousedown: _vm.startResize },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }